<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg7 v-for="(title, i) in TextTitle" :key="i">
            <h2>{{ i + 2 }}. {{ title.nameAPI }}</h2>
            <p class="preindent">
              <b>Request URL :</b> <u> {{ title.url }} </u>
            </p>
            <p class="preindent"><b>Method :</b> {{ title.method }}</p>
            <p class="preindent"><b>Response Format :</b> {{ title.res }}</p>
          </v-flex>
          <v-flex xs11 lg7 mb-5>
            <div style="overflow-x: auto">
              <table id="customers">
                <tr>
                  <th colspan="5">Request Header Description</th>
                </tr>
                <tr>
                  <th>Parameter</th>
                  <th>Type</th>
                  <th>M/O</th>
                  <th>Description</th>
                  <th>Note</th>
                </tr>
                <tr>
                  <td>Authorization</td>
                  <td>String</td>
                  <td class="text-center">M</td>
                  <td>รหัส Authorization หน้าเว็บ CMP</td>
                  <td>Bearer Authorization</td>
                </tr>
              </table>
            </div>
          </v-flex>
          <v-flex xs11 lg7 mb-5>
            <div style="overflow-x: auto">
              <table id="customers">
                <tr>
                  <th colspan="5">Request Body Description</th>
                </tr>
                <tr>
                  <th>Parameter</th>
                  <th>Type</th>
                  <th>M/O</th>
                  <th>Description</th>
                  <th>Note</th>
                </tr>
                <tr>
                  <td>TaxId</td>
                  <td>String</td>
                  <td class="text-center">M</td>
                  <td>เลขนิติบุคคล</td>
                  <td></td>
                </tr>
                <tr>
                  <td>BranchId</td>
                  <td>String</td>
                  <td class="text-center">M</td>
                  <td>สาขาสถานประกอบการผู้ใช้งาน</td>
                  <td></td>
                </tr>
                <tr>
                  <td>Consent</td>
                  <td>Object</td>
                  <td class="text-center">M</td>
                  <td>รหัสความยินยอมและสถานะ</td>
                  <td>[{"ConsentId": "","Status":""}]</td>
                </tr>
                <tr>
                  <td>PolicyId</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>รหัสนโยบาย</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ConsentGroupId</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>รหัสกลุ่มความยินยอม</td>
                  <td></td>
                </tr>
                <tr>
                  <td>AccountId</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>รหัส Account ONE</td>
                  <td rowspan="6" style="vertical-align: baseline">
                    อย่างน้อยต้อง 1 ใน 6
                    ตัวแปรส่งเข้ามาเพื่อบ่งบอกถึงผู้ที่กำลังกด Consent คือใคร
                  </td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>ชื่อผู้ให้ความยินยอม</td>
                </tr>
                <tr>
                  <td>Tel</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>เบอร์โทรศัพท์ผู้ให้ความยินยอม</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>อีเมลผู้ให้ความยินยอม</td>
                </tr>
                <tr>
                  <td>Idcard</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>เลขบัตรประชาชนผู้ให้ความยินยอม</td>
                </tr>
                <tr>
                  <td>Passport</td>
                  <td>String</td>
                  <td class="text-center">O</td>
                  <td>หนังสือเดินทาง</td>
                </tr>
              </table>
            </div>
          </v-flex>
          <v-flex xs12 lg7 mb-5>
            <table id="customers">
              <tr>
                <th>
                  Example Response
                  Body(กรณีส่งข้อมูลถูกต้องและพบข้อมูลความยินยอม) API Send
                  Consent
                </th>
              </tr>
              <tr>
                <td style="background: #2c3538; color: #fff">
                  <div class="text-end">
                    <v-tooltip left color="#077893">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="copyText">
                          <v-icon small color="#fff">
                            mdi-file-multiple
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("consentlist.copy") }}</span>
                    </v-tooltip>
                  </div>
                  <pre ref="text" style="font-weight: 600; font-size: 85%">
{
    <span class="colorkey">"TaxId"</span>: <span class="colorvalue">"0000000000000"</span>,
    <span class="colorkey">"BranchId"</span>: <span class="colorvalue">"00000"</span>,
    <span class="colorkey">"PolicyId"</span>: <span class="colorvalue">""</span>,
    <span class="colorkey">"ConsentGroupId"</span>: <span class="colorvalue">""</span>,
    <span class="colorkey">"Consent"</span>: [
            {
              <span class="colorkey">"ConsentId"</span>: <span class="colorvalue">"xxxxx"</span>,
              <span class="colorkey"> "Status"</span>: <span class="colorvalue">"approve"</span> or <span class="colorvalue">"unapprove"</span>
            },
    ],
    <span class="colorkey">"AccountId"</span>: <span class="colorvalue">""</span>,
    <span class="colorkey">"Name"</span>: <span class="colorvalue">"นายทดสอบ"</span>,
    <span class="colorkey">"Tel"</span>: <span class="colorvalue">""</span>,
    <span class="colorkey">"Email"</span>: <span class="colorvalue">""</span>,
    <span class="colorkey">"Idcard"</span>: <span class="colorvalue">""</span>,
    <span class="colorkey">"Passport"</span>: <span class="colorvalue">""</span>
}

</pre>
                </td>
              </tr>
            </table>
          </v-flex>
          <v-flex xs12 lg7 mb-5>
            <table id="customers">
              <tr>
                <th>
                  Example Response
                  Body(กรณีส่งข้อมูลถูกต้องและพบข้อมูลความยินยอม) API Send
                  Consent
                </th>
              </tr>
              <tr>
                <td style="background: #2c3538; color: #fff">
                  <div class="text-end">
                    <v-tooltip left color="#077893">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="copyText">
                          <v-icon small color="#fff">
                            mdi-file-multiple
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("consentlist.copy") }}</span>
                    </v-tooltip>
                  </div>
                  <pre ref="text" style="font-weight: 600; font-size: 85%">
{
  <span class="colorkey">"Message"</span>: [
        {
          <span class="colorkey">"Consent"</span>: [
                {
                  <span class="colorkey">"ApproveAt"</span>: <span class="colorvalue">"วันเดือนปีและเวลาที่ให้ความยินยอม"</span>,
                  <span class="colorkey">"ConsentDetail"</span>: <span class="colorvalue">"เนื้อหาความยินยอม"</span>,
                    <span class="colorkey">"ConsentHeader"</span>: <span class="colorvalue">"ชื่อหัวข้อความยินยอม"</span>,
                    <span class="colorkey">"ConsentId"</span>: <span class="colorvalue">"รหัสความยินยอม"</span>,
                    <span class="colorkey">"ConsentReject"</span>: <span class="colorvalue">"เนื้อหาหากไม่ยินยอม"</span>,
                    <span class="colorkey">"Level"</span>: <span class="colorvalue">"ระดับของความยินยอม"</span>,
                    <span class="colorkey">"SendAt"</span>: <span class="colorvalue">"วันเดือนปีและเวลาที่ส่งความยินยอม"</span>,
                    <span class="colorkey">"Status"</span>: <span class="colorvalue">"สถานะความยินยอม"</span>
                }
            ],
            <span class="colorkey">"ConsentGroupId"</span>: <span class="colorvalue">"รหัสกลุ่มความยินยอม"</span>,
            <span class="colorkey">"PolicyDetail"</span>: <span class="colorvalue">"เนื้อหานโยบาย"</span>,
            <span class="colorkey">"PolicyHeader"</span>: <span class="colorvalue">"ชื่อหัวข้อนโยบาย"</span>,
            <span class="colorkey">"PolicyId"</span>: <span class="colorvalue">"รหัสนโยบาย"</span>,
            <span class="colorkey">"SourceSystem"</span>: <span class="colorvalue">"ประเภทการส่ง"</span>,
            <span class="colorkey">"AccountId"</span>: <span class="colorvalue">""</span>,
            <span class="colorkey">"Name"</span>: <span class="colorvalue">"นายทดสอบ"</span>,
            <span class="colorkey">"Tel"</span>: <span class="colorvalue">""</span>,
            <span class="colorkey">"Email"</span>: <span class="colorvalue">""</span>,
            <span class="colorkey">"Idcard"</span>: <span class="colorvalue">""</span>,
            <span class="colorkey">"Passport"</span>: <span class="colorvalue">""</span>
        }
    ],
    <span class="colorkey">"Status"</span>: <span class="colorvalue">"OK"</span>,
    <span class="colorkey">"TicketId"</span>: <span class="colorvalue">"xxx"</span>
}

</pre>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: function () {
    return {
      TextTitle: [
        {
          nameAPI: "API Send Consent",
          url: process.env.VUE_APP_API_DOMAIN+"service/provide/SendConsent",
          method: "Post",
          res: "application/json",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    copyText() {
      const text = this.$refs.text.innerText;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
  },
  mounted() {},
  create() {},
};
</script>
<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.mousechange:hover {
  cursor: pointer;
}

h2,
h3 {
  margin: 1.5rem 0 1rem 0;
}

.preindent {
  text-indent: 2rem;
}

#customers {
  border-collapse: collapse;
  width: 100%;
  background-color: #fff;
}

#customers td,
#customers th {
  border: 1px solid gray !important;
  padding: 8px;
}

#customers th {
  text-align: center !important;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #077893;
  color: white;
}

span.colorkey {
  color: #65ef01;
}
span.colorvalue {
  color: #ffee6a;
}
</style>

<style>
/* .v-main__wrap {
  overflow: auto !important;
} */
</style>
